var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"stroke":"#525D70","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M12.666 2.668h-6m2.667 10.667h-6M10 2.668 6 13.335"}})])
}
var staticRenderFns = []

export default { render: render }